// extracted by mini-css-extract-plugin
module.exports = {"renameIcon":"OrganizeArtistModalContent-renameIcon-1ryS-","message":"OrganizeArtistModalContent-message-3gGLw"};